import axios from 'axios';
import { useAuthStore } from '@/stores/authStore';

// 本地开发始终使用 Vite /api 代理；生产构建使用根目录 .env 中的 HTTPS 域名。
export const apiOrigin = (import.meta.env.DEV ? '' : import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '');
const baseURL = apiOrigin
  ? `${apiOrigin}/api`
  : '/api';

export function resolveMediaUrl(url?: string | null): string | undefined {
  if (!url) return undefined;
  if (/^https?:\/\//i.test(url) || url.startsWith('data:') || url.startsWith('blob:')) return url;
  return apiOrigin ? `${apiOrigin}${url.startsWith('/') ? url : `/${url}`}` : url;
}

const request = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface Pagination { page: number; limit: number; total: number; has_more: boolean }

export interface ApiResponse<T = any> {
  pagination?: Pagination;
  code: number;
  data: T;
  message: string;
}

// 请求拦截器：自动附加 token，上传 FormData 时移除默认 Content-Type
request.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.data instanceof FormData && config.headers) {
    delete config.headers['Content-Type'];
    delete config.headers['content-type'];
  }
  return config;
});

request.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const isCanceled = axios.isCancel(error) || error?.code === 'ERR_CANCELED';
    // 只注销本次请求使用的会话；过期请求不能清掉刚登录的新会话。
    const token = useAuthStore.getState().token;
    if (error.response?.status === 401 && token &&
        error.config?.headers?.Authorization === `Bearer ${token}` &&
        error.config?.url !== '/auth/login') {
      useAuthStore.getState().clearAuth();
    }
    if (!isCanceled) {
      console.error('API Error:', error);
    }
    return Promise.reject(error);
  }
);

export default request;

// 健康检查
export function checkHealth(): Promise<ApiResponse<{ status: string; time: string; database: string }>> {
  return request.get('/health');
}
